module.exports = {"top3":["Adults with inappropriate lower back imaging","Potentially avoidable emergency department visits age 65 and older","Adults who are obese"],"bottom3":["Adults without all recommended vaccines","Adults without a usual source of care","Children without a medical home"],"most_improved":["Uninsured children","Uninsured adults","Home health patients without improved mobility"],"most_declined":["Home health patients with a hospital admission","Adults with any mental illness reporting unmet need","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/NV.json
// module id = 273
// module chunks = 143196823979170 184088790168614